
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Free Strategy Doc', href: 'https://app.sellsim.co.uk/free-sales-strategy' },
    { name: 'Custom Training', href: '/custom-training' },
    { name: 'Role-play', href: '/role-play' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
  ];

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center cursor-pointer">
              <img
                src="https://static.readdy.ai/image/1b9c7ad5f72a1508b639eaf4b474b2ef/fcf1903d3a1b3fff5c047a5580e9fd59.png"
                alt="SellSim"
                className="h-12 w-auto object-contain"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <div className="flex items-baseline space-x-8">
              {navigation.map((item) => (
                item.href.startsWith('http') ? (
                  <a
                    key={item.name}
                    href={item.href}
                    className="px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap text-gray-700 hover:text-teal-600 cursor-pointer"
                  >
                    {item.name}
                  </a>
                ) : (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`px-3 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
                      location.pathname === item.href
                        ? 'text-teal-600 border-b-2 border-teal-600'
                        : 'text-gray-700 hover:text-teal-600'
                    }`}
                  >
                    {item.name}
                  </Link>
                )
              ))}
            </div>
            
            {/* Get Started Button */}
            <a
              href="https://app.sellsim.co.uk/get-started"
              className="bg-teal-600 text-white px-6 py-2 rounded-lg font-semibold text-sm hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Started
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-teal-600 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <a href="/about" className="block px-3 py-2 text-gray-700 hover:text-teal-600">About</a>
              <a href="/free-strategy-doc" className="block px-3 py-2 text-gray-700 hover:text-teal-600">Free Strategy Doc</a>
              <a href="/custom-training" className="block px-3 py-2 text-gray-700 hover:text-teal-600">Custom Training</a>
              <a href="/role-play" className="block px-3 py-2 text-gray-700 hover:text-teal-600">Role-play</a>
              <a href="/contact" className="block px-3 py-2 text-gray-700 hover:text-teal-600">Contact</a>
              <a href="/faq" className="block px-3 py-2 text-gray-700 hover:text-teal-600">FAQ</a>
              <a href="https://app.sellsim.co.uk/get-started" className="block px-3 py-2 bg-teal-600 text-white rounded-lg font-semibold hover:bg-teal-700 transition-colors">Get Started</a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
